import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { StatusPage } from 'src/app/models/status-page.model';
import { environment } from 'src/environments/environment';

@Injectable()
export class StatusPagesService {
  constructor(private _http: HttpClient) {}

  public getHealthPage(project: string) {
    return this._http.get<StatusPage>(`${environment.baseUrl}/api/v1/status-pages/${project}`);
  }
}
